/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/** 
 * load in a javascript file.
 */
var loadScript = function(url, callback){

  var script = document.createElement("script")
    script.type = "text/javascript";
 
    if (script.readyState){  //IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function(){
            callback();
        };
    }
 
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};


var myAppJavaScript = function($){
  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });
  //$('body').append('<p>Your app is using jQuery version '+$.fn.jquery+'</p>');
  
  $(".slider-tile").hover(function(ob){
    var imageUrlsString = $( this ).find('img').attr("data-srcset");
    var imageUrls = imageUrlsString.split(",");
	$('.slider-title').hide();
    var sliderbg = $('.slider-bg');
    sliderbg.css('background-image', 'url("' + imageUrls[6] + '")' );
    sliderbg.css('background-repeat', 'no-repeat' );
    sliderbg.css('background-size', '100%' );
    sliderbg.css('background-color', '#fff' );
  });
};


if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
    myAppJavaScript(jQuery191);
  });
} else {
  myAppJavaScript(jQuery);
}

$.fn.extend({
    animateCss: function (animationName, callback) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName);
            $(this).addClass('visible');
            if (callback) {
              callback();
            }
        });
        return this;
    }
})

$('#PaidEdgeNumber').on('change', function() {
  var values = ["1", "2", "3"];
  values.splice( values.indexOf(this.value), 1 );
  
  console.log(values);
  
  if ( $("#FreeEdgeNumber").val() === this.value ) {
    values.splice( values.indexOf($("#FreeEdgeNumber2").val()), 1 );
    $("#FreeEdgeNumber").val(values[0]);
  } else if ( $("#FreeEdgeNumber2").val() === this.value ) {
    values.splice( values.indexOf($("#FreeEdgeNumber").val()), 1 );
    $("#FreeEdgeNumber2").val(values[0]);
  }
});

$('#FreeEdgeNumber').on('change', function() {
  var values = ["1", "2", "3"];
  values.splice( values.indexOf(this.value), 1 );
  
  if ( $("#PaidEdgeNumber").val() === this.value ) {
    values.splice( values.indexOf($("#FreeEdgeNumber2").val()), 1 );
    $("#PaidEdgeNumber").val(values[0]);
  } else if ( $("#FreeEdgeNumber2").val() === this.value ) {
    values.splice( values.indexOf($("#PaidEdgeNumber").val()), 1 );
    $("#FreeEdgeNumber2").val(values[0]);
  }
});

$('#FreeEdgeNumber2').on('change', function() {
  var values = ["1", "2", "3"];
  values.splice( values.indexOf(this.value), 1 );
  
  if ( $("#PaidEdgeNumber").val() === this.value ) {
    values.splice( values.indexOf($("#FreeEdgeNumber").val()), 1 );
    $("#PaidEdgeNumber").val(values[0]);
  } else if ( $("#FreeEdgeNumber").val() === this.value ) {
    values.splice( values.indexOf($("#PaidEdgeNumber").val()), 1 );
    $("#FreeEdgeNumber").val(values[0]);
  }
});

var prefabForm = [];
$('#FreeEdgeType').on('change', function() {
  prefabForm = $('form[name="prefab-form"]').serializeArray();
  SetHiddenEdgeInput();
});

$('#PaidEdgeType').on('change', function() {
  prefabForm = $('form[name="prefab-form"]').serializeArray();
  SetHiddenEdgeInput();
});

function SetHiddenEdgeInput(){
  var edge = $('#PaidEdgeType').val();
  var edge2 = $('#FreeEdgeType').val();
  var hiddenEdge = $("#Edges");
  if(hiddenEdge.val() === undefined)
     hiddenEdge = $('[name="Edge Type"]');
  
  if ( (edge === 'Plain' && edge2 === 'Plain')
  	|| (edge === 'Tapered' && edge2 === 'Plain')
    || (edge === 'Plain' && edge2 === 'Tapered')
  ) {
  	hiddenEdge.val('Plain');  
  } else if ( (edge === 'D200' && edge2 === 'Plain')
  	|| (edge === 'Plain' && edge2 === 'D200')
    || (edge === 'D200' && edge2 === 'Tapered')
	|| (edge === 'Tapered' && edge2 === 'D200')
  ) {
  	hiddenEdge.val('D200');  
  } else if ( edge === 'D200' && edge2 === 'D200') {
   	hiddenEdge.val('D200 X2');  
  } else if ( edge === 'Tapered' && edge2 === 'Tapered') {
	hiddenEdge.val('Tapered'); 
  }
  hiddenEdge.trigger("change");
}


$('#Size').on('focusin', function(){
  prefabForm = $('form[name="prefab-form"]').serializeArray();
});

$('#Size').on('change', function(){
  repopulateForm('Size')
});


$('#Thickness').on('focusin', function(){
  prefabForm = $('form[name="prefab-form"]').serializeArray();
});

$('#Thickness').on('change', function(){
  repopulateForm('Thickness')
});

$('#Edges').on('change', function(){
  repopulateForm('Edges')
});

$('[name="Edge Type"]').on('change', function(){
  repopulateForm('Edge Type')
});

function repopulateForm(caller) {
  setTimeout(function(){
  for (var i = 0; i < prefabForm.length; i++) { 
    if (prefabForm[i].name === caller){
      continue;
    }
    
  	$('[name="' + prefabForm[i].name + '"]').val(prefabForm[i].value)
  }
  });
}


$('#radius').on('change', checkBulkheadDimensions);
$('#height').on('change', checkBulkheadDimensions);
$('#width').on('change', checkBulkheadDimensions);
$('#EndAValue').on('change', checkBulkheadDimensions);
$('#EndBValue').on('change', checkBulkheadDimensions);

function checkBulkheadDimensions() {
  var h = parseInt($('#height').val());
  var w = parseInt($('#width').val());
  var a = parseInt($('#EndAValue').val());
  var b = parseInt($('#EndBValue').val());
    
  if ( isNaN(h) || isNaN(w) || isNaN(a) || isNaN(b)) {
  	$('#dimension-error').text('Combined Dimension Measurements cannot exceed 48 inches');
    return;
  }
  
  var r = (h/2) + ( w*2 / (8*h) );
  var c = 2 * Math.atan( w / (2*(r-h)) );
  
  if ( c < 0 ) 
	c = 360 + c;
  
  l = c *2* Math.PI * r / 360;
  
  var total = l + a + b;
     
  if(total > 48) {
    $('.product__add-to-cart-button').css('pointer-events', 'none');
    $('#dimension-error').text('Combined Dimension Measurements cannot exceed 48 inches');
  } else {
   	$('.product__add-to-cart-button').css('pointer-events', 'none');
    $('#dimension-error').text('');
  }
}



$('#variable-a').on('change', checkDimensions);
$('#variable-b').on('change', checkDimensions);
$('#variable-c').on('change', checkDimensions);
$('#variable-d').on('change', checkDimensions);
$('#variable-e').on('change', checkDimensions);

function checkDimensions() {
  var a = $('#variable-a').val();
  var b = $('#variable-b').val();
  var c = $('#variable-c').val();
  var d = $('#variable-d').val();
  var e = $('#variable-e').val();
  
  if (e != undefined) {
    checkDimensionsHelper([a,b,c,d,e]);
  } else if (d != undefined) {
    checkDimensionsHelper([a,b,c,d]);
  } else if (c != undefined) {
    checkDimensionsHelper([a,b,c]);
  } else if (b != undefined) {
    checkDimensionsHelper([a,b]);
  } else if (a != undefined) {
    checkDimensionsHelper([a]);
  }
}

function checkDimensionsHelper(variables) {
  var total = 0;
  for ( i = 0; i < variables.length; i++){
    if ( variables[i] == '') {
      $('.product__add-to-cart-button').css('pointer-events', 'none');
      $('#dimension-error').text('All dimensions measurements must be entered and the combined dimension cannot exceed 48 inches');
      return;
    }
    total += parseInt(variables[i]);
  }
  
  if(total > 48) {
    $('.product__add-to-cart-button').css('pointer-events', 'none');
    $('#dimension-error').text('Combined Dimension Measurements cannot exceed 48 inches');
  } else {
   	$('.product__add-to-cart-button').css('pointer-events', 'all');
    $('#dimension-error').text('');
  }
}

 $("#variable-a").keydown(numericInputOnly);
 $("#variable-b").keydown(numericInputOnly);
 $("#variable-c").keydown(numericInputOnly);
 $("#variable-d").keydown(numericInputOnly);
 $("#variable-e").keydown(numericInputOnly);
 $("#EndAValue").keydown(numericInputOnly);
 $("#EndBValue").keydown(numericInputOnly);

function numericInputOnly(e) {
  // Allow: backspace, delete, tab, escape, enter and .
  if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
      // Allow: Ctrl+A, Command+A
      (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
      // Allow: home, end, left, right, down, up
      (e.keyCode >= 35 && e.keyCode <= 40)) {
    // let it happen, don't do anything
    return;
  }
  // Ensure that it is a number and stop the keypress
  if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
    e.preventDefault();
  }
}

$('.header_nav__link').addClass('.navigation__entrance-animation');
//$('#shopify-section-home-gallery-1').append('<a class="btn btn--to-secondary btn-machine" href="https://grooveindustries.myshopify.com/pages/machine">Machine</a><a class="btn btn--to-secondary btn-prefab" href="https://grooveindustries.myshopify.com/pages/prefabs">Prefab</a>');
//$('.site-header__logo-image').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
  //$('.image-bar__2-column:nth-child(1)').animateCss('fadeInLeft');
  //$('.image-bar__2-column:nth-child(2)').animateCss('fadeInRight');
//});
